module.exports = __webpack_public_path__ + "media/images/img-astream-cc159fab6ad69aa2edf3e2479a3697fd.jpg";